"use client"

import { useState, useEffect, useRef } from "react"
import "./CAProcess.css"

const ScopingProcess = () => {
  const [activeTab, setActiveTab] = useState("planning")
  const headerRef = useRef(null)
  const textRef = useRef(null)
  const imageRef = useRef(null)
  const tabsRef = useRef(null)

  const tabContent = {
    businessCase: {
      title: "SCOPE REVIEW MEETING",
       description:
        "We start with a Scope Review Meeting where we identify the main project goals, the domains to review, and which metrics we will assess, capturing info about Maintainability, Cyclomatic, Inheritance, Class, and others."
    },
    projectPlan: {
      title: "CODE REVIEW",
       description:
        "We proceed to execute the Code Review by looking at Architecture to understand how the product is built, its principles, and its patterns."
      
    },
    test: {
      title: "TEST REVIEW",
      description:
        "Now it's time for a Test Review, where we assess unit tests, code coverage, and test quality.",
      
    },
     code: {
      title: "CODE QUALITY REVIEW",
      description:
        "We follow up with a Code Quality Review, where we list all the issues and describe them to the fullest, identifying the critical ones and categorising them.",
      
    },
     assesment: {
      title: "ASSESMENT",
      description:
        "We close the process with an Assessment stage where we list all recommended fixes and provide an estimate of the resources needed to implement them.",
      
    },
  }

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible")
          }
        })
      },
      { threshold: 0.1 },
    )

    const elements = [headerRef.current, textRef.current, imageRef.current, tabsRef.current]
    elements.forEach((el) => {
      if (el) observer.observe(el)
    })

    return () => {
      elements.forEach((el) => {
        if (el) observer.unobserve(el)
      })
    }
  }, [])

  return (
    <div className="scoping-container" id="process">
      <div className="container">
      <div className="scoping-wrapper">
        {/* Header */}
        <div className="header-section" ref={headerRef}>
          <h2 className="header-title">
            OUR
            <br />
            <span className="highlight">CODE AUDIT</span>
            <br />
            <span className="highlight">PROCESS</span>
          </h2>
        </div>

        {/* Main Content */}
        <div className="main-content">
          <div className="text-section" ref={textRef}>
            <p className="main-description">
              We believe the process of designing a product or application should be user-centered integrating an innovative and practical approach that considers the users' standards, goals, business requirements, and a top-quality technical side.
            </p>
          </div>
          <div className="image-section" ref={imageRef}>
            <img
              src="/process-scoping.webp?height=300&width=400"
              alt="Scoping Process Illustration"
              className="process-image"
            />
          </div>
        </div>

        {/* Tabs Section */}
        <div className="tabs-container" ref={tabsRef}>
          
          <div className="tabs-header">
            <button
              className={`tab-button ${activeTab === "businessCase" ? "active" : ""}`}
              onClick={() => setActiveTab("businessCase")}
            >
              <div className="tab-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M2 20h20M5 20V8.5M9 20v-9M13 20v-5.5M17 20v-9"></path>
                </svg>
              </div>
              SCOPE REVIEW MEETING
            </button>
            <button
              className={`tab-button ${activeTab === "projectPlan" ? "active" : ""}`}
              onClick={() => setActiveTab("projectPlan")}
            >
              <div className="tab-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="11" cy="11" r="8"></circle>
                  <path d="m21 21-4.35-4.35"></path>
                </svg>
              </div>
              CODE REVIEW
            </button>
            <button
              className={`tab-button ${activeTab === "test" ? "active" : ""}`}
              onClick={() => setActiveTab("test")}
            >
              <div className="tab-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
  <path d="M9 2v6a7 7 0 0 0 5 6.7V20a1 1 0 0 1-2 0v-5.3A7 7 0 0 0 9 8V2z" />
  <path d="M7 22h10" />
</svg>

              </div>
              TEST REVIEW
            </button>
             <button
              className={`tab-button ${activeTab === "code" ? "active" : ""}`}
              onClick={() => setActiveTab("code")}
            >
              <div className="tab-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                  <polyline points="14 2 14 8 20 8"></polyline>
                  <line x1="16" y1="13" x2="8" y2="13"></line>
                  <line x1="16" y1="17" x2="8" y2="17"></line>
                  <polyline points="10 9 9 9 8 9"></polyline>
                </svg>
              </div>
              CODE QUALITY REVIEW
            </button>
             <button
              className={`tab-button ${activeTab === "assesement" ? "active" : ""}`}
              onClick={() => setActiveTab("assesment")}
            >
              <div className="tab-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
  <circle cx="12" cy="12" r="10" />
  <path d="M9 12l2 2l4-4" />
</svg>

              </div>
              ASSESMENT
            </button>
            
            
          </div>

          <div className="tab-content">
            <div className={`tab-panel ${activeTab === "businessCase" ? "active" : ""}`}>
              <h3 className="tab-title3241">{tabContent.businessCase.title}</h3>
              <h4 classname="description">{tabContent.businessCase.description}</h4>
            </div>

            <div className={`tab-panel ${activeTab === "projectPlan" ? "active" : ""}`}>
              <h3 className="tab-title3241">{tabContent.projectPlan.title}</h3>
              <h4 classname="description">{tabContent.projectPlan.description}</h4>
             
            </div>

            <div className={`tab-panel ${activeTab === "test" ? "active" : ""}`}>
              <h3 className="tab-title3241">{tabContent.test.title}</h3>
              <h4 classname="description">{tabContent.test.description}</h4>
            </div>
            <div className={`tab-panel ${activeTab === "code" ? "active" : ""}`}>
              <h3 className="tab-title3241">{tabContent.code.title}</h3>
              <h4 classname="description">{tabContent.code.description}</h4>
              </div>
              <div className={`tab-panel ${activeTab === "assesment" ? "active" : ""}`}>
              <h3 className="tab-title3241">{tabContent.assesment.title}</h3>
              <h4 classname="description">{tabContent.assesment.description}</h4>
              </div>
          </div>
        </div>

        {/* CTA Section */}
        <div className="cta-section">
          <h3 className="cta-title">NEED A QUOTE FOR YOUR PROJECT?</h3>
          <p className="cta-description">
            Our team of business developers and project managers are ready to analyze your questions. Have a coffee,
            free time to explain us everything and get a quote for your project.
          </p>
          <button className="quote-button">GET A QUOTE</button>
        </div>
      </div>
      </div>
      </div>
   
  )
}

export default ScopingProcess;
